<div :class="colums" v-if="marketingBanner.active">
    <div class="tile tile--banner"  :class="{'tile--mobile': userStore.mobile, type }">
        <div class="tile__information"></div>
        <div class="tile__block">
            <div class="tile__block--image">
                <router-link :to="{name:'payment'}" v-if="isLoggedIn()">
                    <img class="banner" :src="marketingBanner.img" />
                </router-link>
                <a v-if="!isLoggedIn()" @click="toggleModal('login')">
                    <img class="banner" :src="marketingBanner.img" />
                </a>
            </div>
        </div>
    </div>
</div>
<div :class="colums" ref="tileElement">
    <div class="tile fadeIn" :class="{'tile--mobile': userStore.mobile, type, 'tile--current': isCurrent }" @mouseenter="!isMobile && debouncedPlayVideo(true)"  @mouseleave="!isMobile && debouncedStopVideo(true)">
        <div class="tile__information" >
            <div class="tile__information--nickname"><span>{{ performer.nickname }}</span></div>
            <div class="tile__information--status"><span :class="'status ' + performerStatusColor(performer)"></span></div>
        </div>
        <div class="tile__block">
            <div class="tile__block--labels">
                <div v-if="!hideLabel" class="label" :class="performerStatusColor(performer)" v-t="'general.labels.' + performerStatusColor(performer)"></div>
            </div>
            <div class="tile__block--services">
                <div class="services">
                    <i v-for="s in availableServices" class="se" :class="`se-${s}`"></i>
                </div>
            </div>
            <div class="tile__block--hearth"><favorite :id="performer.id"></favorite></div>
            <div class="tile__block--image">              
                <router-link :to="tileRoute()">   
                    <div class="loader loader-timeout" v-if="hasVideo() && isLoading" :style="loaderStyle"></div>
                    <div class="avatar-wrapper">
                        <Spinner v-show="!isImageLoaded && !hasVideo()"/>
                        <img class="avatar" ref="avatar" @load="onImageLoad" :src="getAvatar(performer, 'medium')" v-show="showAvatar && !hasVideo()"
                            :alt="'Contact met ' + performer.nickname" />
                        <video v-if="hasVideo()" :class=" { 'fade-in': !showAvatar && isPlaying && !isLoading, 'fade-out': showPoster && !isLoading}" @pause="onPause" ref="videoPlayer" class="avatar-video" controlslist="nodownload noplaybackrate" playsinline muted loop
                            disablepictureinpicture :poster="getAvatar(performer, 'medium')" preload="none">
                        </video>
                    </div>
                </router-link>        
            </div>
            <span class="tile__block--advert">{{ performer.advertNumber }}</span>
        </div>
    </div>
</div>
<div :class="colums" v-if="promoBanner.active">
    <div class="tile tile--banner"  :class="{'tile--mobile': userStore.mobile, type }">
        <div class="tile__information"></div>
        <div class="tile__block">
            <div class="tile__block--image" v-if="promoBanner.type === 'promo'">
                <router-link :to="{name:'payment'}" v-if="isLoggedIn()">
                    <img class="banner" :src="promoBanner.img" />
                </router-link>
                <a v-if="!isLoggedIn()" @click="toggleModal('login')">
                    <img class="banner" :src="promoBanner.img" />
                </a>
            </div>
            <div class="tile__block--image" v-if="promoBanner.type === 'register'">
                <a @click="toggleModal('register')">
                    <img class="banner" :src="promoBanner.img" />
                </a>
            </div>
        </div>
    </div>
</div>